export const state = {
	message: '',
	type: '',
	status: false
}

export const mutations = {

}

export const actions = {
	async toggleBanner ({ state }, { status = true, message = '', type = '' }) {
		state.message = message || ''
		state.type = type || ''
		state.status = status
	}
}

export const getters = {
	getBannerMessage: state => state.message,
	getBannerType: state => state.type,
	getBannerStatus: state => state.status
}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
